import React, { useEffect, useRef } from 'react';
import './header.css';

const nav_links = [
  { path: '#home', display: 'Home' },
  { path: '#about', display: 'About' },
  { path: '#service', display: 'Needs' },
  { path: '#projects', display: 'Services' },
  { path: '#blog', display: 'Prodact' },
  { path: '#contact', display: 'Contact' },
];

function Header({ theme, toggleTheme }) {
  const headerRef = useRef(null);
  const menuRef = useRef(null);

  const headerFunc = () => {
    if (
      document.body.scrollTop > 80 ||
      document.documentElement.scrollTop > 80
    ) {
      headerRef.current.classList.add('header_shrink');
    } else {
      headerRef.current.classList.remove('header_shrink');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', headerFunc);
    return () => window.removeEventListener('scroll', headerFunc);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    const targetAttr = e.target.getAttribute('href');
    const location = document.querySelector(targetAttr).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  const toggleMenu = () => menuRef.current.classList.toggle('menu_active');

  return (
    <header className="header" ref={headerRef}>
      <div className="header_container">
        <div className="nav_wrapper">
          <div className="logo">
            <h2>SmartSen</h2>
          </div>
          <div className="navigation" ref={menuRef} onClick={toggleMenu}>
            <ul className="menu">
              {nav_links.map((item, index) => (
                <li className="menu_item" key={index}>
                  <a
                    href={item.path}
                    onClick={handleClick}
                    className="menu_link"
                  >
                    {item.display}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="light_mode">
            <span onClick={toggleTheme}>
              {theme === 'light-theme' ? (
                <>
                  <i className="ri-moon-line" /> Dark
                </>
              ) : (
                <>
                  <i className="ri-sun-line" /> Light
                </>
              )}
            </span>
          </div>
          <span className="mobile_menu" onClick={toggleMenu}>
            <i className="ri-menu-line" />
          </span>
        </div>
      </div>
    </header>
  );
}

export default Header;
